import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PopularIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M4.22222 2V6.44444M2 4.22222H6.44444M5.33333 17.5556V22M3.11111 19.7778H7.55556M13.1111 2L15.6511 9.61889L22 12L15.6511 14.3811L13.1111 22L10.5711 14.3811L4.22222 12L10.5711 9.61889L13.1111 2Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

PopularIcon.displayName = 'PopularIcon';
